export const CONTACT_INFO = {
  title: "TOTEM ARCHITECTURE Sàrl",
  adresse1: "Rue Saint-Roch 31, 1004 Lausanne",
  name1: "Giulia Altarelli",
  phone1: "+41 79 619 44 79",
};
